import React from 'react'
import LoginModal from '../modals/LoginModal'
import SignupModal from '../modals/SignupModal'

function AuthModals() {
  return (
    <>
      <LoginModal />
      <SignupModal />
    </>
  );
}

export default AuthModals